var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveSupplier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_233",
    "data-name": "Group 233",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35.143,
    viewBox: "0 0 36 35.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 36,
    height: 35.143,
    transform: "translate(0 0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 32,
    height: 32.143,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    "data-name": "Line 18",
    d: "M14.362-5.556H-7.028A1.119,1.119,0,0,1-8-6.778,1.119,1.119,0,0,1-7.028-8H14.362a1.119,1.119,0,0,1,.972,1.222A1.119,1.119,0,0,1,14.362-5.556Z",
    transform: "translate(12.371 13.629)",
    fill: "#5a5858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M-6.778,4.222A1.222,1.222,0,0,1-8,3V-6.778A1.222,1.222,0,0,1-6.778-8,1.222,1.222,0,0,1-5.556-6.778V3A1.222,1.222,0,0,1-6.778,4.222Z",
    transform: "translate(19.762 18.875)",
    fill: "#5a5858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_20",
    "data-name": "Line 20",
    d: "M-6.778,4.222A1.222,1.222,0,0,1-8,3V-6.778A1.222,1.222,0,0,1-6.778-8,1.222,1.222,0,0,1-5.556-6.778V3A1.222,1.222,0,0,1-6.778,4.222Z",
    transform: "translate(25.858 18.875)",
    fill: "#5a5858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M64.6,70.985H49.844A1.981,1.981,0,0,1,48,68.9V49.045a.929.929,0,1,1,1.844,0V68.9H64.6V49.045a.929.929,0,1,1,1.844,0V68.9A1.981,1.981,0,0,1,64.6,70.985Z",
    transform: "translate(-41.184 -43.213)",
    fill: "#5a5858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M93.445,23.333a1.222,1.222,0,0,1-1.222-1.222V19.667A1.224,1.224,0,0,0,91,18.444H83.667a1.224,1.224,0,0,0-1.222,1.222v2.444a1.222,1.222,0,0,1-2.444,0V19.667A3.671,3.671,0,0,1,83.667,16H91a3.671,3.671,0,0,1,3.667,3.667v2.444A1.222,1.222,0,0,1,93.445,23.333Z",
    transform: "translate(-71.305 -14.149)",
    fill: "#5a5858"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSupplier);
export default __webpack_public_path__ + "static/media/remove_supplier.cd45a3888578a71769e2d5e0dd7e357c.svg";
export { ForwardRef as ReactComponent };